import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Directiva encargada de setear el valor de un input a NULL en caso de que el usuario introduzca 'string vacío'.
 */
@Directive({
  selector: 'input[defaultNullValue]'
})
export class DefaultNullValueDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event.target'])
  onEvent(target: HTMLInputElement) {
    this.control.control.setValue(target.value === '' ? null : target.value);
  }
}
